export const PERMISSIONS = {
  // Dashboard & Analytics
  DASHBOARD: {
    VIEW: 'dashboard.view',
    ANALYTICS: 'dashboard.analytics',
    CLINIC_OPERATIONS_VIEW: 'dashboard.clinic-operations.view',
    CLINIC_STATS_VIEW: 'dashboard.clinic-operations.stats.view',
    CLINIC_APPOINTMENTS_VIEW: 'dashboard.clinic-operations.appointments.view',
    CLINIC_DOCTORS_VIEW: 'dashboard.clinic-operations.doctors.view',
    CLINIC_PATIENTS_VIEW: 'dashboard.clinic-operations.patients.view',
    CLINIC_DOCTOR_LEAVES_VIEW: 'dashboard.clinic-operations.doctor-leaves.view',
  },

  // Medical Store Management
  MEDICAL_STORE: {
    VIEW: 'medical-store.view',
    CREATE: 'medical-store.create',
    UPDATE: 'medical-store.update',
    DELETE: 'medical-store.delete',
    EXPORT: 'medical-store.export',
  },

  // Simulation OTP
  SIMULATION_OTP: {
    VIEW: 'otp-simulation.index',
  },

  // Patient Management
  PATIENTS: {
    VIEW: 'patients.view',
    CREATE: 'patients.create',
    UPDATE: 'patients.update',
    DELETE: 'patients.delete',
    EXPORT: 'patients.export',
    PROFILE_VIEW: 'patients.profile.view',
    MEDICAL_HISTORY: 'patients.medical-history.view',
    CONFIRMATION: 'patients.confirmation.manage',
  },

  // Member Management
  MEMBERS: {
    VIEW: 'members.view',
    CREATE: 'members.create',
    UPDATE: 'members.update',
    DELETE: 'members.delete',
    VERIFICATION: 'members.verification.manage',
    EXPORT: 'members.export',
  },

  // Staff Management
  STAFF: {
    VIEW: 'staff.view',
    CREATE: 'staff.create',
    UPDATE: 'staff.update',
    DELETE: 'staff.delete',
    PROFILE_VIEW: 'staff.profile.view',
    EDUCATION_MANAGE: 'staff.education.manage',
    EXPORT: 'staff.export',
    STATUS_UPDATE: 'staff.status.update',
  },

  // Doctor Management
  DOCTORS: {
    VIEW: 'doctors.view',
    CREATE: 'doctors.create',
    UPDATE: 'doctors.update',
    DELETE: 'doctors.delete',
    DASHBOARD: 'doctors.dashboard.view',
    ASSIGNMENT: 'doctors.assignment.manage',
    SCHEDULE: 'doctors.schedule.manage',
  },

  // Appointments
  APPOINTMENTS: {
    VIEW: 'appointments.view',
    CREATE: 'appointments.create',
    UPDATE: 'appointments.update',
    DELETE: 'appointments.delete',
    BOOKING: 'appointments.booking.manage',
    DETAILS: 'appointments.details.view',
    EXPORT: 'appointments.export',
  },

  // Treatments
  TREATMENTS: {
    VIEW: 'treatments.view',
    CREATE: 'treatments.create',
    UPDATE: 'treatments.update',
    DELETE: 'treatments.delete',
    PROTOCOLS: 'treatments.protocols.manage',
    SLOTS: 'treatments.slots.manage',
    EXPORT: 'treatments.export',
  },

  // Services
  SERVICES: {
    VIEW: 'services.view',
    CREATE: 'services.create',
    UPDATE: 'services.update',
    DELETE: 'services.delete',
    SLOTS: 'services.slots.manage',
    EXPORT: 'services.export',
  },

  // Solutions
  SOLUTIONS: {
    VIEW: 'solutions.view',
    CREATE: 'solutions.create',
    UPDATE: 'solutions.update',
    DELETE: 'solutions.delete',
    SLOTS: 'solutions.slots.manage',
    EXPORT: 'solutions.export',
  },

  // Room Management
  ROOMS: {
    VIEW: 'rooms.view',
    CREATE: 'rooms.create',
    UPDATE: 'rooms.update',
    DELETE: 'rooms.delete',
    SLOTS: 'rooms.slots.manage',
    DASHBOARD: 'rooms.dashboard.view',
    STATS_VIEW: 'rooms.dashboard.stats.view',
    INHOUSE_VIEW: 'rooms.dashboard.inhouse.view',
    CHECKIN_VIEW: 'rooms.dashboard.checkin.view',
    CHECKOUT_VIEW: 'rooms.dashboard.checkout.view',
    MEDI_DAYCARE_VIEW: 'rooms.dashboard.medidaycare.view',
    SCHEDULER_VIEW: 'rooms.dashboard.scheduler.view',
    DOWNLOAD_DIET_PLAN: 'rooms.dashboard.dietplan.download',
    DOWNLOAD_TREATMENT_PLAN: 'rooms.dashboard.treatmentplan.download',
    INDIVIDUAL_DATA: 'rooms.individual-data.view',
  },

  // Therapist Management
  THERAPIST: {
    VIEW: 'therapist.view',
    CREATE: 'therapist.create',
    UPDATE: 'therapist.update',
    DELETE: 'therapist.delete',
    ALLOCATION: 'therapist.allocation.manage',
    HISTORY: 'therapist.history.view',
  },

  // Order Management
  ORDERS: {
    VIEW: 'orders.view',
    CREATE: 'orders.create',
    UPDATE: 'orders.update',
    DELETE: 'orders.delete',
    HISTORY: 'orders.history.view',
    PENDING: 'order-pending.index',
    EXPORT: 'orders.export',
  },

  // Coupons
  COUPONS: {
    VIEW: 'coupon.index',
    CREATE: 'coupon.create',
    UPDATE: 'coupon.update',
    DELETE: 'coupon.delete',
  },

  // Bookings
  BOOKINGS: {
    VIEW: 'bookings.view',
    CREATE: 'bookings.create',
    UPDATE: 'bookings.update',
    DELETE: 'bookings.delete',
    PROGRAM_BOOKING: 'bookings.program.manage',
    DETOX_RETREAT: 'bookings.detox-retreat.manage',
  },

  // Programs
  PROGRAMS: {
    VIEW: 'programs.view',
    CREATE: 'programs.create',
    UPDATE: 'programs.update',
    DELETE: 'programs.delete',
  },

  // Consultations
  CONSULTATIONS: {
    VIEW: 'consultations.view',
    CREATE: 'consultations.create',
    UPDATE: 'consultations.update',
    DELETE: 'consultations.delete',
    YOGA: 'consultations.yoga.manage',
  },

  // Case Management
  CASE_MANAGEMENT: {
    VIEW: 'case-management.view',
    VERIFY: 'case-management.verify',
    UPDATE: 'case-management.update',
    INDOOR_CASEPAPER: 'case-management.indoor-casepaper.manage',
  },

  // Indoor Casepaper Actions
  INDOOR_CASEPAPER: {
    VIEW: 'indoor-casepaper.view',
    INITIAL_ASSESSMENT: 'indoor-casepaper.initial-assessment.manage',
    TREATMENT_PLAN: 'indoor-casepaper.treatment-plan.manage',
    MEDICATION: 'indoor-casepaper.medication.manage',
    YOGA: 'indoor-casepaper.yoga.manage',
    DISCHARGE: 'indoor-casepaper.discharge.manage',
  },

  // Testimonials
  TESTIMONIALS: {
    VIEW: 'testimonials.view',
    CREATE: 'testimonials.create',
    UPDATE: 'testimonials.update',
    DELETE: 'testimonials.delete',
    LINKS: 'testimonials.links.manage',
    PATIENT_TESTIMONIALS: 'testimonials.patient.manage',
  },

  // Laboratory
  LABORATORY: {
    VIEW: 'laboratory.view',
    CREATE: 'laboratory.create',
    UPDATE: 'laboratory.update',
    DELETE: 'laboratory.delete',
    INVESTIGATIONS: 'laboratory.investigations.manage',
  },

  // Leaves Management
  LEAVES: {
    VIEW: 'leaves.view',
    CREATE: 'leaves.create',
    UPDATE: 'leaves.update',
    DELETE: 'leaves.delete',
    APPROVE: 'leaves.approve',
  },

  // Gallery
  GALLERY: {
    VIEW: 'gallery.view',
    CREATE: 'gallery.create',
    UPDATE: 'gallery.update',
    DELETE: 'gallery.delete',
    UPLOAD: 'gallery.upload',
  },

  // FAQ Management
  FAQ: {
    VIEW: 'faq.view',
    CREATE: 'faq.create',
    UPDATE: 'faq.update',
    DELETE: 'faq.delete',
  },

  // Celebrities
  CELEBRITIES: {
    VIEW: 'celebrities.view',
    CREATE: 'celebrities.create',
    UPDATE: 'celebrities.update',
    DELETE: 'celebrities.delete',
  },

  // Holidays
  HOLIDAYS: {
    VIEW: 'holidays.view',
    CREATE: 'holidays.create',
    UPDATE: 'holidays.update',
    DELETE: 'holidays.delete',
  },

  // Birthday Folks
  BIRTHDAY_FOLKS: {
    VIEW: 'birthday-folks.view',
  },

  // Discharge Forms
  DISCHARGE_FORMS: {
    VIEW: 'discharge-forms.view',
    CREATE: 'discharge-forms.create',
    UPDATE: 'discharge-forms.update',
    DELETE: 'discharge-forms.delete',
  },

  // Detox Retreat
  DETOX_RETREAT: {
    VIEW: 'detox-retreat.view',
    CREATE: 'detox-retreat.create',
    UPDATE: 'detox-retreat.update',
    DELETE: 'detox-retreat.delete',
  },

  // 20 Min Form
  TWENTY_MIN_FORM: {
    VIEW: '20min-form.view',
    CREATE: '20min-form.create',
    UPDATE: '20min-form.update',
    DELETE: '20min-form.delete',
  },

  // Prakruti Standards
  PRAKRUTI_STANDARDS: {
    VIEW: 'prakruti-standards.view',
    CREATE: 'prakruti-standards.create',
    UPDATE: 'prakruti-standards.update',
    DELETE: 'prakruti-standards.delete',
    TREATMENT_PROTOCOL: {
      VIEW: 'prakruti-standards.treatment-protocol.view',
      CREATE: 'prakruti-standards.treatment-protocol.create',
      UPDATE: 'prakruti-standards.treatment-protocol.update',
      DELETE: 'prakruti-standards.treatment-protocol.delete',
    },
  },

  // Master Data
  MASTER_DATA: {
    VIEW: 'master-data.view',
    CREATE: 'master-data.create',
    UPDATE: 'master-data.update',
    DELETE: 'master-data.delete',
    MEDICINE: {
      VIEW: 'medicine.view',
      CREATE: 'medicine.create',
      UPDATE: 'medicine.update',
      DELETE: 'medicine.delete',
    },
    MEMBERSHIP: {
      VIEW: 'membership.view',
      CREATE: 'membership.create',
      UPDATE: 'membership.update',
      DELETE: 'membership.delete',
    },
    EXERCISE: {
      VIEW: 'exercise.view',
      CREATE: 'exercise.create',
      UPDATE: 'exercise.update',
      DELETE: 'exercise.delete',
    },
    SHIFTS: {
      VIEW: 'shifts.view',
      CREATE: 'shifts.create',
      UPDATE: 'shifts.update',
      DELETE: 'shifts.delete',
    },
    DO_AND_DONTS: {
      VIEW: 'do-and-donts.view',
      CREATE: 'do-and-donts.create',
      UPDATE: 'do-and-donts.update',
      DELETE: 'do-and-donts.delete',
    },
    DIET_PLAN: {
      VIEW: 'diet-plan.view',
      CREATE: 'diet-plan.create',
      UPDATE: 'diet-plan.update',
      DELETE: 'diet-plan.delete',
    },
    DO_DONTS: 'master-data.do-donts.manage',
    THERAPIST_COUNT: {
      VIEW: 'therapist-count.view',
      CREATE: 'therapist-count.create',
      UPDATE: 'therapist-count.update',
      DELETE: 'therapist-count.delete',
    },
    VIRECHAN: {
      VIEW: 'virechan.view',
      CREATE: 'virechan.create',
      UPDATE: 'virechan.update',
      DELETE: 'virechan.delete',
    },
    ROOM_COUNT: 'master-data.room-count.manage',
    CARETAKER_FOOD_PRICE: 'master-data.caretaker-food-price.manage',
  },

  // App Configuration
  APP_CONFIG: {
    VIEW: 'app-config.view',
    CREATE: 'app-config.create',
    UPDATE: 'app-config.update',
    DELETE: 'app-config.delete',
  },

  // Price Tables
  PRICE_TABLES: {
    VIEW: 'price-tables.view',
    CREATE: 'price-tables.create',
    UPDATE: 'price-tables.update',
    DELETE: 'price-tables.delete',
  },

  // Admin Functions
  ADMIN: {
    ROLES_VIEW: 'admin.roles.view',
    ROLES_CREATE: 'admin.roles.create',
    ROLES_UPDATE: 'admin.roles.update',
    ROLES_DELETE: 'admin.roles.delete',
    PERMISSIONS_VIEW: 'admin.permissions.view',
    PERMISSIONS_CREATE: 'admin.permissions.create',
    PERMISSIONS_UPDATE: 'admin.permissions.update',
    PERMISSIONS_DELETE: 'admin.permissions.delete',
    SYSTEM_SETTINGS: 'admin.system-settings.manage',
  },

  // Reports & Analytics
  REPORTS: {
    VIEW: 'reports.view',
    EXPORT: 'reports.export',
    PATIENT_REPORTS: 'reports.patients.view',
    FINANCIAL_REPORTS: 'reports.financial.view',
    STAFF_REPORTS: 'reports.staff.view',
    TREATMENT_REPORTS: 'reports.treatments.view',
    ORDER_REPORTS: 'reports.orders.view',
    ORDER_REPORTS_EXPORT: 'reports.orders.export',
  },

  // System Permissions
  SYSTEM: {
    BACKUP: 'system.backup',
    RESTORE: 'system.restore',
    LOGS_VIEW: 'system.logs.view',
    MAINTENANCE: 'system.maintenance',
  },

  // Role Management
  ROLES: {
    VIEW: 'role.view',
    CREATE: 'role.create',
    UPDATE: 'role.update',
    DELETE: 'role.delete',
  },

  // Permission Management
  PERMISSIONS_MANAGEMENT: {
    VIEW: 'permission.view',
    CREATE: 'permission.create',
    UPDATE: 'permission.update',
    DELETE: 'permission.delete',
  },
};
